function initializeFormButton() {
    var formButton = document.getElementById("form-button");
    var formContainer = document.querySelector(".form-container");
    var hideContent = document.querySelectorAll(".hide-content");

    formButton?.addEventListener("click", function() {
        formContainer.style.display = "block";
        hideContent.forEach(function(element) {
            element.style.display = "none";
        });
    });
}

initializeFormButton();